module.exports = "<spiner></spiner>";